import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-locize-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { locizePlugin } from "locize";

let i18nPipeline = i18n;

if (process.env.NODE_ENV !== "test") {
  i18nPipeline = i18nPipeline.use(Backend).use(locizePlugin).use(LanguageDetector);
}

if (!i18nPipeline.isInitialized) {
  let userLanguage = navigator.language || navigator.languages[0] || "de";

  if (userLanguage.includes("en")) userLanguage = "en";
  if (userLanguage.includes("de")) userLanguage = "de";
  if (userLanguage.includes("es")) userLanguage = "es";

  i18nPipeline.use(initReactI18next).init({
    lng: userLanguage,
    fallbackLng: "de",
    preload: ["en", "de", "es"],
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      projectId: process.env.LOCIZE_PROJECTID
    },
    react: {
      bindI18n: "languageChanged editorSaved",
      transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i", "p"]
    },
    detection: {
      order: ["querystring"],
      caches: []
    }
  });
}

export default i18nPipeline;
